











































import { MemberManagementMemberAddressService as memberAddressApi } from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import MemberAddressEditComponent from "@/components/admin/member/memberAddressEditComponent.vue";
import PostalCode from "@/components/common/postalCode.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberAddressComponent",
  components: {
    QErrors,
    PostalCode,
    MemberAddressEditComponent,
  },
})
export default class MemberAddressComponent extends Vue {
  public memberId = null;
  public memberAddresses = [];
  public async show() {
    this.memberId = this.$router.currentRoute.params?.id;
    if (this.memberId) {
      await this.getDetail();
    }
  }

  public async getDetail() {
    const result = await memberAddressApi.adminMemberAddress({
      memberId: this.memberId,
    });

    this.memberAddresses = result.data.MemberAddress;
  }

  public editAddress(memberAddress = null) {
    (this.$refs.memberAddressEditComponent as MemberAddressEditComponent).show(
      this.memberId,
      memberAddress,
    );
  }
}
